import React, { useEffect, useState } from 'react';
import { Language } from '../types';

interface WelcomeAnimationProps {
  language: Language;
  onComplete: () => void;
}

const WelcomeAnimation: React.FC<WelcomeAnimationProps> = ({ language, onComplete }) => {
  const [numbers, setNumbers] = useState<{ id: number; value: number; style: any }[]>([]);

  useEffect(() => {
    // Generate falling numbers
    const generateNumbers = () => {
      const newNumbers = [];
      for (let i = 0; i < 20; i++) {
        newNumbers.push({
          id: i,
          value: Math.floor(Math.random() * 100),
          style: {
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            animationDuration: `${2 + Math.random() * 3}s`,
          },
        });
      }
      setNumbers(newNumbers);
    };

    generateNumbers();

    // Remove animation after 4 seconds
    const timer = setTimeout(() => {
      onComplete();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 bg-indigo-900 bg-opacity-90 flex items-center justify-center z-50">
      {/* Falling numbers */}
      {numbers.map((num) => (
        <div
          key={num.id}
          className="absolute text-indigo-200 text-2xl animate-fall opacity-50"
          style={num.style}
        >
          {num.value}
        </div>
      ))}

      {/* Welcome message */}
      <div className="text-center z-10">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 animate-slide-up">
          {language === 'en' ? 'Welcome to' : 'Bienvenue dans'}
        </h1>
        <h2 className="text-3xl sm:text-4xl font-bold text-indigo-200 animate-slide-up" style={{ animationDelay: '0.5s' }}>
          {language === 'en' ? 'a new way to learn Math!' : 'une nouvelle façon d\'apprendre les maths !'}
        </h2>
      </div>
    </div>
  );
};

export default WelcomeAnimation;